// v2.28 — un process = un seul schéma : étapes à gauche (de haut en bas), cas particuliers à droite,
// et « › » où le faire dans le site. Sur téléphone, les cas particuliers passent sous leur étape.
import { cn } from '../../lib/utils';

function Box({ item, tone, n }) {
  return (
    <div className={cn('rounded-xl border px-3 py-2 text-sm min-w-0',
      tone === 'case' ? 'bg-amber-50 border-amber-300 text-amber-900' : 'bg-teal-50 border-teal-400 text-teal-900')}>
      <div className="font-bold">{n ? `${n}. ` : ''}{item.title}</div>
      {item.sub && <div className={cn('text-xs', tone === 'case' ? 'text-amber-800' : 'text-teal-800')}>{item.sub}</div>}
      {item.where && <div className="text-xs mt-0.5 opacity-80">› {item.where}</div>}
    </div>
  );
}

export default function ProcessDiagram({ flow }) {
  return (
    <div className="space-y-1" data-testid="process-diagram">
      {flow.map((step, i) => (
        <div key={i}>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-1.5 sm:gap-3 items-start">
            <Box item={step} n={i + 1} />
            {step.cases?.length > 0 && (
              <div className="space-y-1.5 pl-4 sm:pl-0 border-l-2 border-dashed border-amber-300 sm:border-0">
                {step.cases.map((c, j) => <Box key={j} item={c} tone="case" />)}
              </div>
            )}
          </div>
          {i < flow.length - 1 && <div className="w-1/2 sm:w-1/2 text-center text-teal-500 leading-none py-0.5" aria-hidden>↓</div>}
        </div>
      ))}
      <div className="flex gap-4 pt-2 text-[11px] text-slate-500">
        <span className="flex items-center gap-1"><span className="w-3 h-3 rounded bg-teal-50 border border-teal-400" />Chemin normal</span>
        <span className="flex items-center gap-1"><span className="w-3 h-3 rounded bg-amber-50 border border-amber-300" />Cas particulier</span>
        <span>› où le faire</span>
      </div>
    </div>
  );
}
